<p-tree
    [value]="LocationHierarchyTreeComponent.treeItemRoot.children"
    [filter]="true"
    [trackBy]="TreeUtils.treeNodeTrackByKey"
    [virtualScroll]="true"
    [virtualScrollItemSize]="35"
    [loading]="showLoading"
    scrollHeight="calc(100vh - 23rem)"
>
    <ng-template pTemplate="empty">
        <div class="empty-container">
            <p>
                No location existing, please create your first location by pressing the button bellow<br /><span
                    class="pi pi-arrow-down"
                ></span>
            </p>
        </div>
    </ng-template>
    <ng-template let-node pTemplate="default">
        <a
            tabindex="0"
            (click)="selectLocation(node.data, node)"
            (keydown.enter)="selectLocation(node.data, node)"
            (keydown.space)="selectLocation(node.data, node)"
            [ngClass]="
                LocationHierarchyTreeComponent.activeUUIDPath &&
                LocationHierarchyTreeComponent.activeUUIDPath.indexOf(node.data.uuid) !== -1
                    ? 'active'
                    : ''
            "
            [ngStyle]="{cursor: 'pointer'}"
        >
            <b>{{ node.label }}</b>
        </a>
    </ng-template>
</p-tree>
@if (!showLoading) {
    <div class="mt-2">
        <p-button label="Add new" fluid="true" severity="contrast" (onClick)="onNew()"></p-button>
    </div>
}
